import { GridRenderCellParams } from '@mui/x-data-grid';

import { useDateFormat, UseDateFormatProps } from '../../../../hooks/useDateFormat';
import FallbackCell, { FallbackCellProps } from '../FallbackCell';

export interface DateCellProps extends Omit<FallbackCellProps<string | Date>, 'children'> {
  formatProps?: Omit<UseDateFormatProps, 'locale'>;
}

export default function DateCell({ formatProps = {}, ...props }: DateCellProps) {
  const formatDate = useDateFormat(formatProps);

  return <FallbackCell<string | Date> {...props}>{(dateString) => formatDate(new Date(dateString))}</FallbackCell>;
}

export function renderDateCell({ value }: GridRenderCellParams) {
  return <DateCell value={value} />;
}
